import styled from 'styled-components';
import { transition } from 'components/mixins/interactivity';
import { transparentize } from 'utils/color';
import { secondaryFont } from 'components/mixins/typography';
import { Text } from 'components/common';

type ActionButtonsContainerProps = {
  isHidden: boolean;
};

type SubmitOnceButtonWrapperProps = {
  shouldAddAdditionalMargin?: boolean;
};

export const ActionButtonsContainer = styled.div<ActionButtonsContainerProps>`
  ${transition('opacity', '0.2s')};
  opacity: ${props => (props.isHidden ? 0 : 1)};
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;

  & > button {
    margin-bottom: 8px;
    margin-right: 24px;
  }

  & > .tooltip {
    bottom: 105%;
    left: 0;
  }
`;

type NavButtonsBlockProps = {
  tabIndex: number;
};
export const NavButtonsBlock = styled.div.attrs((props: NavButtonsBlockProps) => ({
  tabIndex: props.tabIndex
}))<NavButtonsBlockProps>`
  display: flex;
  flex-wrap: wrap;
  margin-top: 49px;
  width: 100%;
  & > button {
    margin: 0 24px 20px 0;
  }

  &:focus {
    outline: none;
  }
`;

export const SurveyHint = styled.p`
  ${secondaryFont};
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 8px;
  color: ${props =>
    transparentize(props.theme.colors.textColor, props.theme.themeUtils.getOpacity(true, 0.5))};
  align-self: center;

  & + div {
    width: 100%;
  }
`;

type RemainingAttemptsReminderTextProps = {
  ariaLabel: string;
  tabIndex: number;
  role: string;
};
export const RemainingAttemptsReminderText = styled(Text).attrs(
  (props: RemainingAttemptsReminderTextProps) => ({
    tabIndex: props.tabIndex,
    role: props.role,
    'aria-label': props.ariaLabel
  })
)<RemainingAttemptsReminderTextProps>`
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
  color: ${props =>
    transparentize(props.theme.colors.textColor, props.theme.themeUtils.getOpacity(true, 0.4))};

  &:focus {
    outline: none;
  }
`;

export const RemainingAttemptsReminder = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

export const SubmitOnceButtonWrapper = styled.div<SubmitOnceButtonWrapperProps>`
  margin-top: ${props => (props.shouldAddAdditionalMargin ? '49px' : '0')};
`;

export const SubmitOnceButtonMobileWrapper = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: block;
  }
`;
